import { inject } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { throwError } from 'rxjs';
import { ConnectivityService } from '../services/connectivity.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (!inject(ConnectivityService).isOnline()) {
    return throwError(() => new HttpErrorResponse({
      error: { message: 'No internet connection' },
      status: 0,
      statusText: 'Offline',
      url: req.url,
    }));
  }

  const token = localStorage.getItem('token');
  if (!token) return next(req);
  return next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }));
};
